import frame from './PageHead.vue'
const PageHead = {
  install: function (Vue) {
    Vue.component('PageHead', frame)
  }
}
export default PageHead
